import { useMemo } from "react";
import { isCalculatedParameter } from "../../../evergis/core/classification/getFromClassified";
import { useCurrentLayerName } from "../../../hooks/layer/useCurrentLayer";
import { usePostgresLayer } from "../../../hooks/layer/usePostgresLayer";
import { CalculatedAble, ParameterValue } from "../../../interfaces/style";
import { useLayerAttributes } from "../../Dialogs/InfoResource/hooks/useLayerAttributes";

export const getExpressionAttributeName = <V extends ParameterValue>(parameter: CalculatedAble<V>) =>
  (isCalculatedParameter(parameter) && parameter.expression) || null;

export const useExpressionAttribute = <V extends ParameterValue>(parameter: CalculatedAble<V>) => {
  const layerName = useCurrentLayerName();
  const {
    postgresLayer: { layerDefinition },
  } = usePostgresLayer(layerName, { waitInput: true });
  const layerAttributes = useLayerAttributes(layerDefinition);

  return useMemo(() => {
    const attributeName = getExpressionAttributeName(parameter);

    if (!attributeName) return null;

    return layerAttributes.find(attribute => attribute.attributeName === attributeName) || null;
  }, [layerAttributes, parameter]);
};
